var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { HubPlaceAdditionalData } from '../../../models/hub/hub.google.place.data';
import { BaseComponent } from '../../../common/components/base.component';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { EventTimeService } from '../../../services/event.time.service';
import { isNullOrUndefined } from '../../../common/extensions';
var VisitorPlaceOpeningHoursComponent = /** @class */ (function (_super) {
    __extends(VisitorPlaceOpeningHoursComponent, _super);
    function VisitorPlaceOpeningHoursComponent() {
        return _super.call(this) || this;
    }
    VisitorPlaceOpeningHoursComponent.prototype.ngOnInit = function () {
        if (this.isMobile) {
            this.useShortWeekdays();
        }
        try {
            this.getIsOpenNow();
        }
        catch (e) {
            console.log(e);
        }
    };
    VisitorPlaceOpeningHoursComponent.prototype.useShortWeekdays = function () {
        this.googlePlaceAdditionalData.opening_hours.weekday_text =
            this.googlePlaceAdditionalData.opening_hours.weekday_text.map(function (x) {
                var seg = x.split(': ');
                return seg[0].substr(0, 3) + ": " + seg[1];
            });
    };
    VisitorPlaceOpeningHoursComponent.prototype.getIsOpenNow = function () {
        if (!this.googlePlaceAdditionalData ||
            !this.googlePlaceAdditionalData.opening_hours ||
            !this.googlePlaceAdditionalData.opening_hours.periods)
            return;
        var timezoneFormatterDefault = localStorage.getItem(localStorageKeys.timezoneFormatterDefault);
        var hour;
        if (timezoneFormatterDefault) {
            hour = EventTimeService.getLocalHourByFormatter(new Date(), timezoneFormatterDefault);
        }
        if (isNullOrUndefined(hour))
            return;
        var openingHours = this.googlePlaceAdditionalData.opening_hours.periods;
        // open 24 hours everyday
        if (openingHours.length === 1 && openingHours[0].open.day === 0 && openingHours[0].open.time === '0000') {
            this.googlePlaceAdditionalData.opening_hours.open_now = true;
            return;
        }
        var weekdayOfToday = new Date().getDay();
        var weekdayStatuses = openingHours.filter(function (x) { return x.open.day === weekdayOfToday && x.open.time && x.close.time; });
        if (!weekdayStatuses.length) {
            this.googlePlaceAdditionalData.opening_hours.open_now = false;
        }
        else {
            for (var _i = 0, weekdayStatuses_1 = weekdayStatuses; _i < weekdayStatuses_1.length; _i++) {
                var status_1 = weekdayStatuses_1[_i];
                var open_1 = parseInt(status_1.open.time, 10) / 100;
                var close_1 = parseInt(status_1.close.time, 10) / 100;
                close_1 = close_1 === 0 ? 24 : close_1;
                var isOpen = open_1 <= hour && close_1 > hour;
                if (isOpen) {
                    this.googlePlaceAdditionalData.opening_hours.open_now = isOpen;
                    return;
                }
            }
            this.googlePlaceAdditionalData.opening_hours.open_now = false;
        }
    };
    return VisitorPlaceOpeningHoursComponent;
}(BaseComponent));
export { VisitorPlaceOpeningHoursComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.opening.hours/place.opening.hours.component.ts.pre-build-optimizer.js